<template>
  <div class="animated fadeIn">
    <form>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">Indicadores de Carbono</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >Selecione o(s) projeto(s) para visualizar os
                      gráficos</label
                    >

                    <v-select
                      placeholder="Digite o nome do projeto"
                      v-model="project"
                      :options="[
                        { label: 'Todos', id: $store.getters.emptyGuid },
                        ...projects
                      ]"
                      multiple
                      required
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div
                  v-if="!loading"
                  class="col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-4"
                >
                  <button
                    class="btn btn-primary mr-2"
                    type="button"
                    @click="OnChangeProject"
                  >
                    Filtrar
                  </button>
                </div>
                <div v-else class="col-1 mt-4">
                  <div class="loader">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-card-group id="cardsCount" deck class="mb-4">
            <b-card
              bg-variant="primary"
              text-variant="white"
              header="Total de indivíduos arbóreos vivos"
              class="text-center"
            >
              <b-card-text>
                <span style="font-size: 20px">
                  {{ totalCard.alive }}
                </span>
              </b-card-text>
            </b-card>

            <b-card
              bg-variant="info"
              text-variant="white"
              header="Estimativa total (Ton./CO2)"
              class="text-center"
            >
              <b-card-text>
                <span style="font-size: 20px">
                  {{ totalCard.stock }}
                </span>
              </b-card-text>
            </b-card>

            <b-card
              bg-variant="success"
              text-variant="white"
              header="Total crédito $"
              class="text-center"
            >
              <b-card-text>
                <span style="font-size: 20px">
                  {{ totalCard.valuation }}
                </span>
              </b-card-text>
            </b-card>
          </b-card-group>

          <div class="card">
            <div class="row mb-3">
              <div
                v-if="markers.length > 0"
                class="col-sm-12 col-md-6 col-lg-6 col-xl-6"
              >
                <div class="form-group">
                  <h5 class="m-2">
                    Distribuição espacial dos 10 indivíduos Árboreos/Palmeira
                    com maior estoque de carbono (CO2/Kg.)
                  </h5>
                  <GoogleMaps :markers="markers" class="m-2"/>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <highcharts id="chartPie" v-if="chartPie" :options="chartPie" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <highcharts id="chartBar" v-if="chartBar" :options="chartBar" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
  
  <script>
import RotateSquare from "../../components/RotateSquare";
import CarbonService from "../../servico/CarbonService";
import ProjectService from "../../servico/ProjectService";
import { Chart } from "highcharts-vue";
import GoogleMaps from "../../components/GoogleMaps";

export default {
  name: "StockCarbon",
  components: {
    RotateSquare,
    highcharts: Chart,
    GoogleMaps
  },
  data() {
    return {
      loading: false,
      project: null,
      projects: [],
      chartPie: null,
      chartBar: null,
      markers: [],
      totalCard: {
        alive: 0,
        stock: 0,
        valuation: 0
      }
    };
  },
  mounted() {
    this.OnSearchProjects("    ");
  },
  methods: {
    OnSearchProjects(term) {
      if (!term || term.length <= 2) return;

      ProjectService.GetVSelect(term, true)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    OnChangeProject() {
      this.viewModel = null;
      let filter = this.project.map((a) => {
        return a.id;
      });
      this.loading = true;
      this.markers = [];
      this.chartPie = null;
      this.chartBar = null;

      CarbonService.GetTotalCard(filter)
        .then((resposta) => {
          this.loading = false;
          this.totalCard = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      CarbonService.GetTop(filter)
        .then((resposta) => {
          this.loading = false;
          this.markers = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      CarbonService.GetChartPie(filter)
        .then((result) => {
          this.loadingFilter = false;

          this.chartPie = CarbonService.ToPie(
            result.data,
            "Sequestro de carbono (Ton./CO2)"
          );
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      CarbonService.GetChartBar(filter)
        .then((result) => {
          this.loadingFilter = false;

          this.chartBar = CarbonService.ToBarColum(
            result.data,
            "Indicação dos 10 indivíduos arbóreos/palmeira com maior estoque de carbono (CO2/Kg)"
          );
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
  